export default __webpack_public_path__ + "static/media/17.745df769.png";